import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { LenderListing } from '../shared/lender-listing.model';

@Injectable({
    providedIn: 'root'
})
export class LenderService {
    private stateSubject = new BehaviorSubject<string>('');
    private listings$: Observable<LenderListing[]>;

    constructor(private httpClient: HttpClient, private appConfig: AppConfigService) {
        this.listings$ = this.stateSubject.pipe(
            switchMap(state => state != '' ?
                this.httpClient.get<Array<LenderListing>>(this.appConfig.fruAPI + '/best/lenders?state=' + state).pipe(
                    map(response => Array.isArray(response) ? response : []),
                    catchError(error => {
                        console.error('LenderService: failed to load lender listings', error);
                        return of([]);
                    })
                ) : []
            )
        );
    }

    getState(): Observable<string> {
        return this.stateSubject.asObservable();
    }

    getListings(): Observable<LenderListing[]> {
        return this.listings$;
    }

    setState(state: string): void {
        this.stateSubject.next(state);
    }
}
